import type { TravelEstimate } from '../utils/geo';
import { formatTravelEstimate } from '../utils/geo';

interface TravelIndicatorProps {
  estimate: TravelEstimate | null;
}

export function TravelIndicator({ estimate }: TravelIndicatorProps) {
  if (!estimate) return null;

  return (
    <div className="flex items-center justify-center py-1.5 relative">
      <div className="travel-pill">
        <span className="material-symbols-outlined text-sm">
          {estimate.icon}
        </span>
        <span>{formatTravelEstimate(estimate)}</span>
      </div>
    </div>
  );
}
